import React, { Fragment } from 'react'
import cn from 'classnames'
import PropTypes from 'prop-types'
import { useTranslation } from '@mc/i18n'
import Article from './Article'
import classes from './Articles.module.scss'

const Articles = ({ articles }) => {
  const { t } = useTranslation('@mc/algolia-search')

  if (articles.length > 0) {
    const renderedArticles = articles
      .slice(0, 5)
      .map((article) => <Article key={article.slug} hit={article} />)
    return (
      <Fragment>
        <div className={cn(classes.header, 'mc-text-h5 mc-p-4')}>
          {t('searchResults.articlesHeading')}
        </div>
        {renderedArticles}
      </Fragment>
    )
  }
  return null
}

Articles.propTypes = {
  articles: PropTypes.array,
}

export default Articles
